"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const interfaces_1 = require("./interfaces");
const menu_1 = require("./menu");
exports.mapNavBarItem = (collapsed, height, onShouldCollapse, x, i) => {
    if (x.visible == false)
        return null;
    return (React.createElement(NavBarItemComponent, { items: x.items, collapsed: collapsed, height: height, key: i, onShouldCollapse: onShouldCollapse, selected: x.selected, onClick: x.onClick, borderless: x.borderless }, x.content));
};
class NavBarItemComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleDocumentClick = (ev) => {
            const isMenuFunc = (target) => {
                if (target == null)
                    return false;
                if (target == this.divRef) {
                    return true;
                }
                return isMenuFunc(target.parentNode);
            };
            const isMenu = isMenuFunc(ev.target);
            if (!isMenu)
                this.setState({ open: false });
        };
        this.handleOnMouseEnter = () => {
            this.setState({ hover: true });
        };
        this.handleOnMouseLeave = () => {
            this.setState({ hover: false });
        };
        this.handleOnClick = () => {
            if (this.props.onClick)
                this.props.onClick();
            //Solo se debe de colapsar la barra si este no es un menu 
            if (this.props.onShouldCollapse && (!this.props.items || this.props.items.length == 0))
                this.props.onShouldCollapse();
            this.setState(prev => ({ open: !prev.open }));
        };
        this.handleRef = (div) => {
            this.divRef = div;
        };
        this.state = { hover: false, open: false };
    }
    componentWillMount() {
        document.addEventListener("click", this.handleDocumentClick);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.handleDocumentClick);
    }
    render() {
        const itemPadding = this.props.borderless ? undefined : "0 10px 0 10px";
        const navBarItemStyle = {
            height: this.props.height + "px",
            cursor: "pointer",
            position: "relative",
            padding: itemPadding,
            justifyContent: "center",
            flexDirection: "column",
            display: "flex",
            float: this.props.collapsed ? undefined : "left"
        };
        const getBackgroundColor = (hover, selected, normal) => {
            return this.state.hover ? hover : this.props.selected ? selected : normal;
        };
        const background = getBackgroundColor(interfaces_1.darkHover, interfaces_1.darkSelected, undefined);
        const showMenuItems = this.state.open && this.props.items;
        const div = React.createElement("div", { ref: this.handleRef, style: Object.assign({}, navBarItemStyle, { background }), onMouseEnter: this.handleOnMouseEnter, onMouseLeave: this.handleOnMouseLeave, onClick: this.handleOnClick },
            this.props.children,
            showMenuItems && !this.props.collapsed && this.props.items &&
                React.createElement(menu_1.NavBarMenu, { items: this.props.items, height: this.props.height }));
        return (this.props.collapsed ?
            React.createElement("div", { style: { position: "relative" } },
                div,
                showMenuItems && this.props.collapsed &&
                    React.createElement("div", { style: { marginLeft: "5px" } }, this.props.items &&
                        this.props.items
                            .filter(x => x)
                            .map((x, i) => x && exports.mapNavBarItem(true, this.props.height, this.props.onShouldCollapse, x, i)))) : div);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/navbar/item.js
// module id = 2242
// module chunks = 0